import { FC, useEffect } from 'react'
import { UseFormGetValues } from 'react-hook-form'
import clsx from 'clsx'

import ChangePhone from '../change-phone/change-phone'
import EnterEmail from '../enter-email-btn/enter-email-btn'
import NewRegBtn from '../new-reg-btn/new-reg-btn'

import { FormValues, RegStep } from '../../data'
import { FieldsNameVoc } from 'constants/auth/profile-data'
import { A_signinProgress, stepRegProgress } from 'utils/analytics/other/registration/registration'

import styles from './nophone-widget.module.scss'
import common from '../../registration-code.module.scss'

interface INOPhoneReg {
  getValues: UseFormGetValues<FormValues>
  setStep: React.Dispatch<React.SetStateAction<RegStep>>
}

const NOPhoneReg: FC<INOPhoneReg> = ({ setStep, getValues }) => {
  useEffect(() => {
    A_signinProgress(stepRegProgress.NO_PHONE)
  }, [])

  return (
    <div className={common.wrapperCommon}>
      <div className={common.title}>Номер не найден</div>
      <div className={clsx(common.subtitle)}>
        <div>{`Пользователь с номером ${getValues()[FieldsNameVoc.phone]} не найден`}</div>
        <ChangePhone setStep={setStep} />
      </div>
      <div className={styles.bottomBtns}>
        <EnterEmail getValues={getValues} setStep={setStep} />
        <NewRegBtn setStep={setStep} />
      </div>
    </div>
  )
}

export default NOPhoneReg
